import styled from 'styled-components';

import { Button, RadiusConfig } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const TooltipStyle = styled.div`
  .tippy-content {
    padding: 0;
  }
  .tippy-box {
    border-radius: 12px;
  }
`;

export const ButtonOnboardingResults = styled(Button)`
  padding: 11px 24px;
  border-radius: ${RadiusConfig.sm}px;
  background-color: ${COLOR_CONFIG.white};
  font-size: 16px;
  line-height: calc(22 / 16);
  font-weight: 600;
  color: ${COLOR.surfaceNeutralBold['neutral-11']};
`;
